/**
 * @description 移动端自动消失的提示框
 * @param {string} msg 提示文案
 * @param {number} duration 可选，显示时间: ms，默认1500ms
 */
const popMsg = (msg: string, duration?: number): void => {
  duration = duration || 1500;
  const msgDom = document.createElement('div');
  msgDom.textContent = msg;
  msgDom.setAttribute(
    'style',
    `
        position: fixed;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        z-index: 999999;
        left: 50%;
        top: 48%;
        transform: translate(-50%, -50%);
        padding: 2.6vw;
        background-color: rgba(0, 0, 0, 1);
        border-radius: 2.5vw;
        opacity: 0.8;
        font-size: 4vw;
        font-family: STHeitiSC-Light, STHeitiSC;
        font-weight: 300;
        color: rgba(255, 255, 255, 1);
        max-height: 90vh;
        box-sizing: border-box;
        line-height: 4.5vw;
        text-align: center;
        overflow: hidden;`,
  );
  document.body.appendChild(msgDom);
  setTimeout(() => {
    msgDom.remove();
  }, duration);
};

export default popMsg;
